export default "__VITE_ASSET__DXHEhMby__"